'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _watchAppNotifier = require('common/components/mixins/watch-app-notifier');

var _watchAppNotifier2 = _interopRequireDefault(_watchAppNotifier);

var _member = require('./member');

var _member2 = _interopRequireDefault(_member);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

var _teamReporting = require('hellosign/team-reporting');

var _teamReporting2 = _interopRequireDefault(_teamReporting);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var TeamPage = _react2['default'].createClass({
    displayName: 'TeamPage',


    /**
    */

    mixins: [_watchAppNotifier2['default']],

    /**
    */

    propTypes: {
        csrfToken: _react2['default'].PropTypes.string,
        baseFormCsrfToken: _react2['default'].PropTypes.string.isRequired
    },

    /**
    */

    getInitialState: function getInitialState() {
        var app = this.props.app;
        return {
            app: app,
            user: app.user,
            team: app.user.getTeam(),
            teamMembers: app.user.getTeam().getMembers()
        };
    },


    /**
    */

    toggleEditTeamName: function toggleEditTeamName() {
        this.setState({ editTeamName: !this.state.editTeamName }, function () {
            var node = this.refs.teamNameInput;
            node.focus();
            node.setSelectionRange(this.state.team.name.length, this.state.team.name.length);
        }.bind(this));
    },


    /**
    */

    saveTeamName: function saveTeamName(event) {
        var _this = this;

        var teamName = this.refs.teamNameInput.value.trim();

        if (teamName.length === 0) {
            teamName = 'Untitled Team';
        }

        this.state.team.set('name', teamName);
        this.setState({ editTeamName: false });
        this.state.team.save().then(function (err) {

            if (err.error_msg) {
                var err = new Error(err.error_msg);
                _this.setState({ 'error': err });
            }
        });
        event.preventDefault();
    },


    /**
    */

    addTeamMember: function addTeamMember(event) {
        var _this2 = this;

        return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
            var ref, teamMemberEmail, i;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:

                            _this2.setState({ 'error': void 0 });

                            event.preventDefault();

                            if (!_this2.state.csvFile) {
                                _context.next = 12;
                                break;
                            }

                            _context.prev = 3;
                            _context.next = 6;
                            return _this2.state.team.importTeamMembers(_this2.state.csvFile);

                        case 6:
                            _context.next = 11;
                            break;

                        case 8:
                            _context.prev = 8;
                            _context.t0 = _context['catch'](3);

                            _this2.setState({ 'error': _context.t0 });

                        case 11:
                            return _context.abrupt('return');

                        case 12:
                            ref = _this2.refs.newMemberEmailAddress;
                            teamMemberEmail = ref.value || '';

                            // TODO - move this to model

                            if (_hfReactHelper2['default'].isValidEmailAddress(teamMemberEmail)) {
                                _context.next = 16;
                                break;
                            }

                            return _context.abrupt('return', _this2.setState({
                                'error': new Error('Please enter a valid email address!')
                            }));

                        case 16:
                            i = 0;

                        case 17:
                            if (!(i < _this2.state.teamMembers.length)) {
                                _context.next = 23;
                                break;
                            }

                            if (!(_this2.state.teamMembers.at(i).emailAddress === teamMemberEmail)) {
                                _context.next = 20;
                                break;
                            }

                            return _context.abrupt('return', _this2.setState({
                                'error': new Error('That user is already on your team.')
                            }));

                        case 20:
                            i++;
                            _context.next = 17;
                            break;

                        case 23:
                            if (!_this2.state.team.pastTeamMemberLimit()) {
                                _context.next = 29;
                                break;
                            }

                            if (!_this2.state.team.enterpriseProRateAmount) {
                                _context.next = 28;
                                break;
                            }

                            return _context.abrupt('return', _this2.state.app.actions.ui.showModal(_react2['default'].createElement(
                                'div',
                                { className: 'l-new-modal' },
                                _react2['default'].createElement(
                                    'div',
                                    { className: 'l-new-modal--content-wrap' },
                                    _react2['default'].createElement(
                                        'div',
                                        { className: 'l-new-modal--title' },
                                        'New seat needed'
                                    ),
                                    _react2['default'].createElement(
                                        'div',
                                        { className: 'l-new-modal--content' },
                                        _react2['default'].createElement(
                                            'p',
                                            null,
                                            'To invite this person to your team, please purchase a new seat.'
                                        ),
                                        _react2['default'].createElement(
                                            'p',
                                            null,
                                            'Each seat you add will be billed at your rate of ',
                                            _react2['default'].createElement(
                                                'b',
                                                null,
                                                _this2.state.team.enterprisePrice,
                                                '/',
                                                _this2.state.team.enterprisePeriod
                                            ),
                                            '.',
                                            _react2['default'].createElement('br', null),
                                            'This seat will be prorated at ',
                                            _react2['default'].createElement(
                                                'b',
                                                null,
                                                _this2.state.team.enterpriseProRateAmount
                                            ),
                                            ' for this ',
                                            _this2.state.team.enterprisePeriod,
                                            '.'
                                        )
                                    ),
                                    _react2['default'].createElement(
                                        'div',
                                        { className: 'l-new-modal--actions' },
                                        _react2['default'].createElement(_button2['default'], {
                                            buttonText: 'Cancel',
                                            buttonColor: 'white',
                                            buttonTextColor: 'grasshopper',
                                            buttonHoverColor: 'grasshopper',
                                            buttonClass: 'm-button-butmit close',
                                            buttonBorderColor: 'grasshopper',
                                            buttonHoverTextColor: 'white' }),
                                        _react2['default'].createElement(_button2['default'], {
                                            buttonText: 'Continue',
                                            onClick: _this2._addTeamMember.bind(_this2, teamMemberEmail, ref),
                                            buttonColor: 'grasshopper',
                                            buttonHoverColor: 'ashen',
                                            buttonClass: 'm-button-butmit close',
                                            buttonHoverTextColor: 'white' })
                                    )
                                )
                            ), { 'showCloseButton': false }, 'new-enterprise-seat'));

                        case 28:
                            return _context.abrupt('return', _this2.setState({
                                error: new Error('You need to upgrade to add more team members.')
                            }));

                        case 29:

                            _this2._addTeamMember(teamMemberEmail, ref);

                        case 30:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2, [[3, 8]]);
        }))();
    },


    /**
    */

    _addTeamMember: function _addTeamMember(teamMemberEmail, ref) {
        var _this3 = this;

        return _asyncToGenerator(regeneratorRuntime.mark(function _callee2() {
            var member, title, msg;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:

                            _this3.setState({ 'addingTeamMember': true });

                            _context2.prev = 1;
                            _context2.next = 4;
                            return _this3.state.team.addMember({
                                emailAddress: teamMemberEmail,
                                csrfToken: _this3.props.csrfToken
                            });

                        case 4:
                            member = _context2.sent;
                            _context2.next = 10;
                            break;

                        case 7:
                            _context2.prev = 7;
                            _context2.t0 = _context2['catch'](1);
                            return _context2.abrupt('return', _this3.setState({ error: _context2.t0, addingTeamMember: false }));

                        case 10:

                            _this3.setState({
                                error: void 0,
                                addingTeamMember: false
                            });

                            // Clear the input field
                            ref.value = '';

                            // Generate dialog modal with outcome message
                            if (member) {
                                if (typeof member.warning !== "undefined") {
                                    title = member.pending_email_confirmation ? "Invitation Pending" : "Invitation Sent";
                                    msg = member.warning;
                                } else {
                                    title = "Member Added";
                                    msg = "The new member was added successfully.";
                                }
                                _this3.state.app.actions.ui.showModal(_react2['default'].createElement(
                                    'div',
                                    { className: 'l-new-modal' },
                                    _react2['default'].createElement(
                                        'div',
                                        { className: 'l-new-modal--content-wrap' },
                                        _react2['default'].createElement(
                                            'div',
                                            { className: 'l-new-modal--title' },
                                            title
                                        ),
                                        _react2['default'].createElement(
                                            'div',
                                            { className: 'l-new-modal--content' },
                                            _react2['default'].createElement(
                                                'p',
                                                null,
                                                msg
                                            )
                                        ),
                                        _react2['default'].createElement(
                                            'div',
                                            { className: 'l-new-modal--actions' },
                                            _react2['default'].createElement(_button2['default'], {
                                                buttonText: 'Close',
                                                buttonColor: 'grasshopper',
                                                buttonHoverColor: 'ashen',
                                                buttonClass: 'm-button-submit close',
                                                buttonHoverTextColor: 'white' })
                                        )
                                    )
                                ), { 'showCloseButton': false }, 'invite-existing-account');
                            }

                        case 13:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this3, [[1, 7]]);
        }))();
    },


    /**
    */

    onCSVFile: function onCSVFile(file) {
        this.setState({ csvFile: file });
    },


    /**
    */

    render: function render() {

        var canModifyTeam = this.state.team.isOwner && this.state.team.maxSize > 1;
        var sections = {};

        if (this.state.team.maxSize < Infinity) {
            sections.bucketUsage = _react2['default'].createElement(
                'p',
                { className: 'bucket-usage' },
                'You have used ',
                _react2['default'].createElement(
                    'span',
                    { id: 'team_size_display' },
                    this.state.team.size
                ),
                ' of ',
                this.state.team.maxSize,
                ' team seats.',
                _react2['default'].createElement(
                    'a',
                    { className: 'team-page-more-seats', href: '/info/pricing' },
                    'UPGRADE FOR MORE SEATS'
                )
            );
        }

        if (this.props.showReportingLink) {
            sections.reporting = _react2['default'].createElement(
                'p',
                { className: 'bucket-usage' },
                _react2['default'].createElement(_teamReporting2['default'], {
                    csrfToken: this.props.baseFormCsrfToken,
                    isEnabled: this.props.isReportingEnabled,
                    canRequestUsage: this.props.canRequestUsageReport
                })
            );
        }

        // still not done - don't impl for now (CC)
        /*
        if (this.state.csvFile) {
        sections.uploadCSVButton = <form className='csv_import'>
        <span onClick={this.onCSVFile.bind(this, void 0)} id='csv_import_link'>Cancel</span>
        </form>
        } else {
        sections.uploadCSVButton = <UploadCSVButton onFile={this.onCSVFile} />;
        }
        */

        if (canModifyTeam) {
            sections.editTeamName = _react2['default'].createElement(
                'a',
                { href: '#', id: 'edit_team_name_link', onClick: this.toggleEditTeamName },
                _react2['default'].createElement('img', { className: 'team-page-edit-title', src: require('./team_edit_icon_@2x.png') })
            );

            sections.addTeamMember = _react2['default'].createElement(
                'div',
                null,
                sections.bucketUsage,
                sections.reporting,
                _react2['default'].createElement(
                    'form',
                    { className: 'add_team_member', onSubmit: this.addTeamMember },
                    _react2['default'].createElement('input', {
                        ref: 'newMemberEmailAddress',
                        type: 'text', name: 'new_member_email_address',
                        placeholder: this.state.csvFile ? this.state.csvFile.name : void 0,
                        className: 'required email new_member_email_address no_focus',
                        disabled: !!this.state.csvFile || this.state.addingTeamMember }),
                    _react2['default'].createElement(
                        'div',
                        { id: 'add-team-member-submit-react-holder' },
                        _react2['default'].createElement(_button2['default'], {
                            buttonId: this.state.csvFile ? 'csv_import_submit' : 'add_team_member_submit',
                            buttonText: this.state.csvFile ? 'Invite People' : this.state.addingTeamMember ? 'Inviting...' : 'Invite',
                            buttonColor: 'grasshopper',
                            buttonHoverColor: 'ashen',
                            buttonClass: 'm-button-butmit',
                            buttonHoverTextColor: 'white',
                            type: 'submit' })
                    )
                ),
                sections.uploadCSVButton
            );
        } else if (this.state.team.isOwner) {
            sections.addTeamMember = _react2['default'].createElement(
                'div',
                null,
                sections.bucketUsage
            );
        }

        if (this.state.editTeamName) {
            sections.editTeamName = _react2['default'].createElement(
                'form',
                { onSubmit: this.saveTeamName, className: 'edit-team-title-form' },
                _react2['default'].createElement('input', { type: 'text', ref: 'teamNameInput', defaultValue: this.state.team.name }),
                _react2['default'].createElement(_button2['default'], { buttonText: 'Save', onClick: this.saveTeamName, buttonColor: 'grasshopper', buttonHoverColor: 'ashen', buttonClass: 'm-button-butmit', buttonHoverTextColor: 'white' })
            );
        } else {
            sections.editTeamName = _react2['default'].createElement(
                'h1',
                null,
                _react2['default'].createElement(
                    'span',
                    { id: 'team_name' },
                    this.state.team.name || 'Untitled Team'
                ),
                sections.editTeamName
            );
        }

        if (this.state.error) {
            sections.error = _react2['default'].createElement(
                'div',
                { id: 'error_container' },
                _react2['default'].createElement(
                    'label',
                    { htmlFor: 'new_member_email_address', className: 'error' },
                    this.state.error.message
                )
            );
        }

        sections.teamMembers = this.state.teamMembers.map(function (teamMember, i) {
            return _react2['default'].createElement(_member2['default'], { app: this.props.app, key: teamMember.emailAddress + i, member: teamMember, teamMembers: this.state.teamMembers });
        }.bind(this));

        return _react2['default'].createElement(
            'div',
            { className: 'team-page' },
            _react2['default'].createElement(
                'div',
                { className: 'team-accounts-column ' + (_hfReactHelper2['default'].isHelloSign() ? 'hs' : 'hf') },
                sections.editTeamName,
                sections.addTeamMember,
                sections.error,
                _react2['default'].createElement(
                    'div',
                    { id: 'team_list_header' },
                    _react2['default'].createElement(
                        'div',
                        { id: 'member_email' },
                        'Member Email'
                    ),
                    _react2['default'].createElement(
                        'div',
                        { id: 'role' },
                        'Role'
                    ),
                    _hfReactHelper2['default'].isHelloSign() ? _react2['default'].createElement(
                        'div',
                        { id: 'templates' },
                        'Templates Owned'
                    ) : void 0
                ),
                _react2['default'].createElement(
                    'div',
                    { id: 'team_list_container' },
                    _react2['default'].createElement(
                        'table',
                        { className: 'team_list' },
                        _react2['default'].createElement(
                            'tbody',
                            null,
                            sections.teamMembers
                        )
                    )
                )
            )
        );
    }
});

module.exports = TeamPage;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/app/content/team/index.jsx
 ** module id = 846
 ** module chunks = 0
 **/